// frontend/src/components/litters/LitterForm.js
// The pup-management modal: edit a litter's date/notes and its pup records.
//
// Mostly layout. The pup table, the mobile pup list and the three bulk-edit
// control panels stay parent-owned and arrive as render functions — they read
// a wide slice of LitterManagement's state (selection, auto-tag settings,
// per-pup edits), so passing that through as props would be a larger surface
// than passing the renderers themselves. Functions rather than elements so a
// desktop render never builds the mobile tree, and vice versa.

import React from 'react';

function LitterForm({
  managingLitter,
  isMobile,
  overlayRef,
  onLitterDetailChange,
  onAddPup,
  // parent-owned sub-renderers
  renderPupTable,
  renderMobilePupList,
  renderMobileAutoTagControls,
  renderMobileBulkControls,
  renderBulkControls,
  // mobile bulk-edit affordances
  pupsSelectedForManagement,
  isBulkEditExpanded,
  // submit / cancel
  onSave,
  isSubmitting,
  onCancel,
  // feedback
  error,
}) {
  const fieldStyle = {
    width: '100%',
    boxSizing: 'border-box',
    padding: '0.5rem',
    border: '1px solid #ced4da',
    borderRadius: '8px',
    fontSize: '16px',
  };

  return (
    <div ref={overlayRef} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
      <div style={{ backgroundColor: 'white', padding: isMobile ? '15px' : '30px', borderRadius: '8px', maxWidth: isMobile ? '100%' : '1400px', width: isMobile ? '100%' : '95%', height: isMobile ? '100%' : 'auto', maxHeight: isMobile ? '100%' : '90vh', overflow: 'hidden', display: 'flex', flexDirection: 'column', ...(isMobile && { borderRadius: 0, height: '100%', maxHeight: '100%', paddingTop: 'calc(4rem + env(safe-area-inset-top, 0px))', paddingBottom: 'calc(3.5rem + env(safe-area-inset-bottom, 0px))' }) }}>
        <div className="litter-details-form" style={{ display: 'flex', gap: '1.5rem', marginBottom: '0.5rem', height: '44px' }}>
          <div style={{ flex: '0 0 30%', maxWidth: '160px' }}>
            <input
              type="date"
              value={managingLitter.date_of_birth}
              onChange={(e) => onLitterDetailChange('date_of_birth', e.target.value)}
              style={{ ...fieldStyle, height: '60%' }}
            />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <textarea
              value={managingLitter.notes}
              onChange={(e) => onLitterDetailChange('notes', e.target.value)}
              placeholder="Notes"
              rows="1"
              style={{ ...fieldStyle, height: '100%', display: 'block', resize: 'none' }}
            />
          </div>
        </div>
        {error && <div className="error">{error}</div>}

        <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '15px', overflow: 'hidden', paddingTop: '5px' }}>
          <div className="litter-list-container" style={{ flex: 1, minHeight: 0, overflowY: 'auto', overflow: 'auto', display: 'flex', flexDirection: 'column', overscrollBehavior: 'contain', WebkitOverflowScrolling: 'touch' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
              <h4 style={{ paddingLeft: '10px' }}>Pups ({managingLitter.pup_records.length})</h4>
              <button onClick={onAddPup} className="primary-button" style={{ width: 'auto', padding: '5px 10px', marginRight: '10px' }}>
                + Add Pup
              </button>
            </div>
            {isMobile ? renderMobilePupList() : renderPupTable()}
          </div>

          {isMobile && (
            <div style={{ flexShrink: 0 }}>
              {/* Auto-tagging control is always visible; bulk-edit only with a selection */}
              {renderMobileAutoTagControls()}
              {pupsSelectedForManagement.length > 0 && renderMobileBulkControls()}
            </div>
          )}
          {!isMobile && <div style={{ flexShrink: 0 }}>{renderBulkControls()}</div>}
        </div>

        {/* On mobile the expanded bulk-edit panel owns the footer, so hide these */}
        <div className="modal-actions" style={{ flexShrink: 0, marginTop: 'auto', paddingTop: '15px', borderTop: '1px solid #eee', display: 'flex', gap: '10px' }}>
          {(!isMobile || !isBulkEditExpanded) && (
            <>
              <button onClick={onSave} className="primary-button" style={{ flex: 1 }} disabled={isSubmitting}>
                {isSubmitting ? 'Saving...' : 'Save'}
              </button>
              <button onClick={onCancel} className="secondary-button" style={{ flex: 1 }}>
                Cancel
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default LitterForm;
